/**
 * Schiffs-Baukosten pro Typ. SYNC mit supabase/functions/build-ship/index.ts.
 */
import type { ShipType } from './ShipTypes';

export interface ShipBuildCost {
  feronium: number;
  chrysalium: number;
  neurogel: number;
}

/** Bauzeit in Sekunden pro ShipType. SYNC mit build-ship/index.ts. */
export const SHIP_BUILD_TIMES: readonly number[] = [
  30,    // Scout
  60,    // Fighter
  90,    // Bucaneer
  300,   // Battleship
  600,   // ICSS
  900,   // Carrier
  720,   // Receptor
  1200,  // Colonyship
];

/** Index = ShipType. Muss mit build-ship/index.ts identisch sein. */
export const SHIP_BUILD_COSTS: readonly ShipBuildCost[] = [
  { feronium: 100, chrysalium: 50, neurogel: 50 },     // Scout
  { feronium: 200, chrysalium: 100, neurogel: 100 },   // Fighter
  { feronium: 250, chrysalium: 120, neurogel: 120 },   // Bucaneer
  { feronium: 500, chrysalium: 250, neurogel: 250 },   // Battleship
  { feronium: 800, chrysalium: 400, neurogel: 400 },   // ICSS
  { feronium: 1000, chrysalium: 500, neurogel: 500 },  // Carrier
  { feronium: 900, chrysalium: 450, neurogel: 450 },   // Receptor
  { feronium: 1500, chrysalium: 750, neurogel: 750 },  // Colonyship
];

export function getShipBuildCost(type: ShipType): ShipBuildCost {
  return SHIP_BUILD_COSTS[type];
}
